'use es6';

import { push } from 'FormsUI/actions/HistoryActions';
import { getAbmFormSubmission } from 'FormsUI/api/Submissions';
import { getAbmFormSubmission as getAbmFormSubmissionSelector } from 'FormsUI/selectors/Submissions';
import { getSubmissionRoute } from 'FormsUI/lib/RouteGenerators';
function createAction(name) {
  return `@@submissions/${name}`;
}
export const REQUEST_FORM_SUBMISSIONS = createAction('REQUEST_FORM_SUBMISSIONS');
export const SUCCEED_GETTING_FORM_SUBMISSIONS = createAction('SUCCEED_GETTING_FORM_SUBMISSIONS');
export const FAIL_GETTING_FORM_SUBMISSIONS = createAction('FAIL_GETTING_FORM_SUBMISSIONS');
export const REQUEST_FORM_SUBMISSIONS_ANALYTICS = createAction('REQUEST_FORM_SUBMISSIONS_ANALYTICS');
export const SUCCEED_GETTING_FORM_SUBMISSIONS_ANALYTICS = createAction('SUCCEED_GETTING_FORM_SUBMISSIONS_ANALYTICS');
export const FAIL_GETTING_FORM_SUBMISSIONS_ANALYTICS = createAction('FAIL_GETTING_FORM_SUBMISSIONS_ANALYTICS');
export const RECEIVE_FORM_SUBMISSIONS_ANALYTICS = createAction('RECEIVE_FORM_SUBMISSIONS_ANALYTICS');
export const UPDATE_SUBMISSIONS_PAGE_NUMBER = createAction('UPDATE_SUBMISSIONS_PAGE_NUMBER');
export const REQUEST_ABM_FORM_SUBMISSION = createAction('REQUEST_ABM_FORM_SUBMISSION');
export const REQUEST_ABM_FORM_SUBMISSION_SUCCESS = createAction('REQUEST_ABM_FORM_SUBMISSION_SUCCESS');
export const REQUEST_ABM_FORM_SUBMISSION_FAIL = createAction('REQUEST_ABM_FORM_SUBMISSION_FAIL');
function updateSubmissionsPageNumber(number) {
  return {
    type: UPDATE_SUBMISSIONS_PAGE_NUMBER,
    number
  };
}
export const requestAbmFormSubmission = conversionId => ({
  type: REQUEST_ABM_FORM_SUBMISSION,
  conversionId
});
export const requestAbmFormSubmissionSuccess = (conversionId, submission) => ({
  type: REQUEST_ABM_FORM_SUBMISSION_SUCCESS,
  conversionId,
  submission
});
export const requestAbmFormSubmissionFail = conversionId => ({
  type: REQUEST_ABM_FORM_SUBMISSION_FAIL,
  conversionId
});
export function fetchAbmFormSubmission(conversionId) {
  return (dispatch, getState) => {
    if (!getAbmFormSubmissionSelector(getState(), conversionId).requestState.shouldBeRequested()) return Promise.resolve();
    dispatch(requestAbmFormSubmission(conversionId));
    getAbmFormSubmission(conversionId).then(response => {
      dispatch(requestAbmFormSubmissionSuccess(conversionId, response));
    }, error => {
      dispatch(requestAbmFormSubmissionFail(conversionId, error.xhr));
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return undefined;
  };
}
export function openFormSubmission(conversionId, formId) {
  return dispatch => {
    dispatch(push(getSubmissionRoute(formId, conversionId)));
  };
}
export function updatePageNumber(number) {
  return dispatch => {
    dispatch(updateSubmissionsPageNumber(number));
  };
}